
import ProfilesView from "~/views/profilesView.vue";
import { mapGetters, mapMutations } from "vuex";
import { capitalize, getHashIndex } from "~/common/helpers.js";
import { spacesToDashes } from "~/common/helpers";

import IconCol1 from "~/components/v2/icons/IconCol1.vue";

export default {
  components: {
    IconCol1,
    ProfilesView,
  },

  provide() {
    return {
      decodedDistrictId: this.decodedDistrict?.id,
    };
  },

  layout: "catalog",

  data() {
    return {
      profilesCount: 0,
    };
  },

  head() {
    return {
      title: this.meta.title || "EmiratesEscorts",

      link: [
        {
          rel: "canonical",
          href: this.canonicalUrl,
        },
      ],

      meta: [
        {
          hid: "description",
          name: "description",
          content: this.meta.description || "EmiratesEscorts",
        },
        {
          hid: "og:title",
          name: "og:title",
          content: this.meta.title || "EmiratesEscorts",
        },
        {
          hid: "og:description",
          name: "og:description",
          content: this.meta.description || "EmiratesEscorts",
        },
        {
          property: "og:image",
          hid: "og:image",
          name: "og:image",
          content: "https://erowall.com/wallpapers/large/3156.jpg",
        },
        {
          name: "robots",
          content: this.isIndexNeeded ? "all" : "noindex",
        },
      ],
    };
  },

  computed: {
    ...mapGetters({
      catalogMode: "catalog/getCatalogMode",
      catalogMinCol: "catalog/getMinCol",
      profilesDay: "profiles/getProfilesDay",
      currentCity: "global/getCurrentCity",
      decodedRouteParams: "profiles/getDecodedRouteParams",
      processedSeoTexts: "global/getProcessedSeoTexts",
      catalogPageRequestData: "category/getCatalogPageRequestData",
      currentCityUrl: "global/getCurrentCityUrl",
      filtersList: "profiles/getFiltersList",
    }),

    isIndexNeeded() {
      if (this.$route.path.includes("/dubai/male/for-man-services-escorts")) {
        return false;
      }

      return (
        (process.env.NODE_ENV == "production" &&
          this.isRouteIncludeGender &&
          this.profilesCount >= 5 &&
          !(
            this.city &&
            this.decodedDistrict &&
            this.decodedRouteParams?.length >= 3
          )) ||
        // request from client
        (process.env.NODE_ENV == "production" &&
          [
            "/dubai-sharjah/female/indian-nationality-escorts",
            "/dubai-sharjah/female/pakistani-escorts",
            "/dubai-bur-dubai/female/indian-nationality-escorts",
            "/dubai-bur-dubai/female/pakistani-escorts",
            "/male/iranian-escorts",
            "/abu-dhabi/female/com",
            "/dubai/female/latvian-escorts",
            "/shemale/brazilian-escorts",
            "/dubai/female/african-caribbean-escorts",
            "/female/british-escorts",
            "/dubai-al-barsha/transgender/bdsm",
            "/dubai-deira/male/african-caribbean-escorts",
            "/dubai-deira/female/egyptian-escorts",
            "/dubai-al-barsha/male/filipino-escorts",
            "/dubai/female/arabic-escorts",
            "/dubai/female/japanese-escorts",
          ].includes(this.$route.path))
      );
    },

    canonicalUrl() {
      const canonicalMap = {
        "/dubai/transgender/verified": "/dubai/transgender",
        "/dubai/transgender/com": "/dubai/transgender",
        "/dubai-sharjah/female/pakistani-escorts":
          "/dubai/female/pakistani-escorts",
        "/dubai/male/verified": "/dubai/male",
        "/dubai/female/fingering": "/dubai/female",
        "/dubai-dubai-marina/transgender": "/dubai/transgender",
        "/transgender/natural-breast": "/dubai/transgender",
        "/transgender/big-ass": "/dubai/transgender",
        "/dubai/transgender/incall-services-escorts": "/dubai/transgender",
        "/dubai/transgender/revers-oral": "/dubai/transgender",
        "/transgender/silicone-breast": "/dubai/transgender",
      };

      if (canonicalMap[this.$route.path]) {
        return `${this.$config.baseUrlApp}${canonicalMap[this.$route.path]}`;
      }

      return `${this.$config.baseUrlApp}${this.$route.fullPath}`;
    },

    level() {
      // catalog-first-level
      // catalog-second-level
      // catalog-third-level
      return this.$route.name;
    },

    isLocation() {
      return this.decodedRouteParams?.some((p) => p.type == "location");
    },

    city() {
      return this.currentCity.name || "";
    },

    decodedDistrict() {
      let decodedLocation = this.decodedRouteParams?.find(
        (p) => p.type == "location"
      );
      let district;

      if (decodedLocation?.filter_value && decodedLocation?.filter_value[1]) {
        let areaId = decodedLocation.filter_value[1];
        district = this.filtersList?.districts?.find((f) => f.id == areaId);
      }

      return district;
    },

    gender() {
      const genders = {
        female: "Girls",
        transgender: "Shemale",
        male: "Male",
      };
      return this.decodedGender ? genders[this.decodedGender] : "";
    },

    seoGender() {
      const genders = {
        female: "Girls",
        transgender: "Ladyboys",
        male: "Men",
      };
      return this.decodedGender ? genders[this.decodedGender] : "";
    },

    seoGenderSingle() {
      const genders = {
        female: "Girl",
        transgender: "Ladyboy",
        male: "Male",
      };
      return this.decodedGender ? genders[this.decodedGender] : "";
    },

    decodedGender() {
      return this.decodedRouteParams?.find((p) => p.type == "gender")?.name;
    },

    category() {
      let category = this.decodedRouteParams?.find(
        (p) => p.type == "category"
      )?.name;
      return category
        ? category.charAt(0).toUpperCase() + category.slice(1)
        : "";
    },

    service() {
      let service = this.decodedRouteParams?.find(
        (p) => p.type == "service"
      )?.name;
      return service ? service.charAt(0).toUpperCase() + service.slice(1) : "";
    },

    nationality() {
      let nationality = this.decodedRouteParams?.find(
        (p) => p.type == "nationality"
      )?.name;
      if (nationality) {
        nationality = nationality
          .replace("-escorts", "")
          .replace("-nationality", "");
        nationality =
          nationality.charAt(0).toUpperCase() + nationality.slice(1);
        return nationality;
      } else {
        return "";
      }
    },

    ethnicity() {
      return this.decodedRouteParams?.find((p) => p.name == "ethnicity")?.value;
    },

    ethnicitySplitted() {
      switch (this.ethnicity) {
        case "European(White) Female Escort":
          return {
            first: "European",
            second: "White",
          };
        case "Asian Female Escort":
          return {
            first: "Asian",
            second: "Asian",
          };
        case "African / Caribbean Female Escort":
          return {
            first: "African",
            second: "Caribbean",
          };
        case "Latina/O Female Escort":
          return {
            first: "Latina",
            second: "Latina",
          };
        case "Arabic Female Escort":
          return {
            first: "Arabic",
            second: "Arabic",
          };
        case "Indian Female Escort":
          return {
            first: "Indian",
            second: "Indian",
          };
        case "Mixed / Other Female Escort":
          return {
            first: "Mixed",
            second: "Other",
          };
        default:
          return {
            first: this.ethnicity,
            second: this.ethnicity,
          };
      }
    },

    isRouteIncludeGender() {
      const genders = ["male", "female", "transgender"];

      return genders.some((g) => this.$route.path.includes(g));
    },

    meta() {
      /*
        Один уровень вложености:
          /location
          /gender
          /category
          /service
          /nationality

        Два уровня вложености:
          /location/gender
          /location/category
          /location/service
          /location/nationality

        Три уровня вложености:
          /location/gender/category
          /location/gender/service
          /location/gender/nationality
			*/

      /*
			From seo doc

			POPULAR SERVICES:
				title:
					Explore [Adjective] [Category Name] Escorts | Emiratescort
				description:
					Discover [Adjective] [Category Name] escorts on Emiratescort in [Geo].
					Immerse yourself in a world of desires with our [Category Name] escorts. Only for you!
				h1:
					current

			FETISH SERVICES:
				title:
					[Fetish Name] Services - Unleash Your Desires with Emiratescort
				description:
					Fulfill your deepest desires with our skilled [Fetish Name] escorts at Emiratescort in [Geo].
					Experience a world of passion and kink with our [Fetish Name] companions.
				h1:
					current

			MASSAGE SERVICES:
				title:
					Enjoy Sensual [Escort Service Name] Services | Emiratescort
				description:
					Experience a relaxing [Escort Service Name] services with Emiratescort in [Geo].
					Reconnect with pleasure in the company of our expert companions.
				h1:
					current

			OTHER SERVICES:
				title:
					[Service Name] Services - Spice Up Your Night with Emiratescort
				description:
					Fulfill your fantasies with our adventurous [Service Name] escorts in [Geo].
					Dive into a world of pleasure and excitement with Emiratescort tonight!
				h1:
					Current

			Для фильтров:
				title:
					[Filter Name] Escorts | Emiratescort
				description:
					Connect with [Filter Name]  escorts on Emiratescort in [Geo].
					Dive into exciting experiences with Awaiting Call escort models waiting for your call!
				h1:
					Current
		 */

      let meta = {
        title: "",
        description: "",
        h1: undefined,
      };

      if (this.level == "catalog-first-level") {
        if (this.isLocation) {
          meta.title = this.$t("seo.catalog.first-level.location.title", [
            this.city,
            this.decodedDistrict?.title || "",
          ]);
          meta.description = this.$t(
            "seo.catalog.first-level.location.description",
            [this.city, this.decodedDistrict?.title || ""]
          );
          meta.h1 = this.$t("seo.catalog.first-level.location.h1", [
            this.currentCity.name,
            this.decodedDistrict?.title || "",
          ]);
        } else if (this.gender) {
          meta.title = this.$t("seo.catalog.first-level.gender.title", [
            this.gender,
          ]);
          meta.description = this.$t(
            "seo.catalog.first-level.gender.description",
            [this.gender]
          );
          meta.h1 = this.$t("seo.catalog.first-level.gender.h1", [this.gender]);
        } else if (this.category) {
          meta.title = this.$t("seo.catalog.first-level.category.title", [
            this.category,
          ]);
          meta.description = this.$t(
            "seo.catalog.first-level.category.description",
            [this.category]
          );
          meta.h1 = this.$t("seo.catalog.first-level.category.h1", [
            this.category,
          ]);
        } else if (this.service) {
          meta = this.processServiceMeta();
          meta.h1 = this.$t("seo.catalog.first-level.service.h1", [
            this.service,
          ]);
        } else if (this.nationality) {
          meta.title = this.$t("seo.catalog.first-level.nationality.title", [
            this.nationality,
          ]);
          meta.description = this.$t(
            "seo.catalog.first-level.nationality.description",
            [this.nationality]
          );
          meta.h1 = this.$t("seo.catalog.first-level.nationality.h1", [
            this.nationality,
          ]);
        }
      } else if (this.level == "catalog-second-level") {
        if (this.gender) {
          meta.title = this.$t("seo.catalog.second-level.gender.title", [
            this.gender,
            this.currentCity.name,
            this.decodedDistrict?.title || "",
          ]);
          meta.description = this.$t(
            "seo.catalog.second-level.gender.description",
            [
              this.gender,
              this.currentCity.name,
              this.decodedDistrict?.title || "",
            ]
          );
          meta.h1 = this.$t("seo.catalog.second-level.gender.h1", [
            this.gender,
            this.currentCity.name,
            this.decodedDistrict?.title || "",
          ]);
        }
      } else if (this.level == "catalog-third-level") {
        if (this.category) {
          /**
           * HAIR SEO
           */
          if (["Blonde", "Black", "Brunette", "Red"].includes(this.category)) {
            meta.title = this.$t(
              "seo.catalog.third-level.category.hair_color.title",
              [
                this.category.replace(" escort", ""),
                this.currentCity.name,
                this.decodedDistrict?.title || "",
                this.seoGender,
              ]
            );
            meta.description = this.$t(
              "seo.catalog.third-level.category.hair_color.description",
              [
                this.category.replace(" escort", ""),
                this.currentCity.name,
                this.decodedDistrict?.title || "",
                this.seoGender,
              ]
            );
            meta.h1 = this.$t("seo.catalog.third-level.category.h1", [
              this.category.replace(" escort", ""),
              this.gender,
              this.currentCity.name,
              this.decodedDistrict?.title || "",
            ]);
          } else if (
            /**
             * BODY SEO
             */
            [
              "Big-ass",
              "Silicone breast",
              "Natural breast",
              "Bbw",
              "Petite",
              "Skinny",
              "Big-boob",
              "Slim",
            ].includes(this.category)
          ) {
            meta.title = this.$t(
              "seo.catalog.third-level.category.body-type.title",
              [
                this.gender,
                this.category.replace(" escort", ""),
                this.currentCity.name,
                this.decodedDistrict?.title || "",
              ]
            );
            meta.description = this.$t(
              "seo.catalog.third-level.category.body-type.description",
              [
                // this.gender,
                this.category.replace(" escort", ""),
                this.currentCity.name,
                this.decodedDistrict?.title || "",
              ]
            );
            meta.h1 = this.$t("seo.catalog.third-level.category.h1", [
              this.gender,
              this.category,
              this.currentCity.name,
              this.decodedDistrict?.title || "",
            ]);
          } else if (
            ["Online-services", "Man", "Woman", "Couples"].includes(
              this.category
            )
          ) {
            /**
             * BROWSE BY SERVICING AND CATERING templates
             */
            meta.title = this.$t(
              "seo.catalog.third-level.category.catering.title",
              [
                // this.gender,
                this.category.replace(" escort", ""),
                this.currentCity.name,
                // this.decodedDistrict?.title || "",
              ]
            );
            meta.description = this.$t(
              "seo.catalog.third-level.category.catering.description",
              [
                // this.gender,
                this.category.replace(" escort", ""),
                this.currentCity.name,
                // this.decodedDistrict?.title || "",
              ]
            );
            meta.h1 = this.$t("seo.catalog.third-level.category.h1", [
              this.gender,
              this.category,
              this.currentCity.name,
              this.decodedDistrict?.title || "",
            ]);
          } else {
            meta.title = this.$t(
              "seo.catalog.third-level.category.from-seo.title",
              [
                // this.gender,
                this.category.replace(" escort", ""),
                this.currentCity.name,
                // this.decodedDistrict?.title || "",
              ]
            );
            meta.description = this.$t(
              "seo.catalog.third-level.category.from-seo.description",
              [
                // this.gender,
                this.category.replace(" escort", ""),
                this.currentCity.name,
                // this.decodedDistrict?.title || "",
              ]
            );
            meta.h1 = this.$t("seo.catalog.third-level.category.h1", [
              this.gender,
              this.category,
              this.currentCity.name,
              this.decodedDistrict?.title || "",
            ]);
          }
        } else if (this.service) {
          meta = this.processServiceMeta();

          if (!meta.title) {
            meta.title = this.$t("seo.catalog.third-level.service.title", [
              this.gender,
              this.service,
              this.currentCity.name,
              this.decodedDistrict?.title || "",
            ]);
          }

          if (!meta.description) {
            meta.description = this.$t(
              "seo.catalog.third-level.service.description",
              [this.gender, this.service]
            );
          }

          if (!meta.h1) {
            meta.h1 = this.$t("seo.catalog.third-level.service.h1", [
              this.gender,
              this.service,
              this.currentCity.name,
              this.decodedDistrict?.title || "",
            ]);
          }
        } else if (this.nationality) {
          const adjectivs = ["Elite", "Stunning", "Best", "Exclusive"];
          const adjective =
            adjectivs[getHashIndex(this.nationality, adjectivs.length)];
          meta.title = this.$t("seo.catalog.third-level.nationality.title", [
            adjective,
            this.nationality,
            this.seoGender,
            this.currentCity.name,
          ]);
          meta.description = this.$t(
            "seo.catalog.third-level.nationality.description",
            [this.currentCity.name, adjective, this.nationality, this.seoGender]
          );
          meta.h1 = this.$t("seo.catalog.third-level.nationality.h1", [
            this.seoGender,
            this.nationality,
            this.currentCity.name,
            this.decodedDistrict?.title || "",
          ]);
        } else if (this.ethnicity) {
          meta.title = this.$t(
            "seo.catalog.third-level.ethnicity.from-seo.title",
            [this.ethnicitySplitted.first, this.currentCity.name]
          );
          meta.description = this.$t(
            "seo.catalog.third-level.ethnicity.from-seo.description",
            [this.ethnicitySplitted.second, this.currentCity.name]
          );
          meta.h1 = this.$t("seo.catalog.third-level.ethnicity.from-seo.h1", [
            this.ethnicity.replace(" Escort", ""),
            this.currentCity.name,
            this.decodedDistrict?.title || "",
          ]);
        }
      }

      this.$store.commit("global/setSeoKeys", {
        city: this.currentCity.name,
        district: this.decodedDistrict?.title || "",
        gender: this.gender,
        seoGender: this.seoGender,
        seoGenderSingle: this.seoGenderSingle,
        catalogEntity:
          this.category || this.service || this.nationality || this.ethnicity,
      });

      meta.title = this.processedSeoTexts?.title || meta.title;
      meta.description =
        this.processedSeoTexts?.description || meta.description;
      meta.h1 = this.processedSeoTexts?.h1 || meta.h1;

      let page = this.$route.query.page;
      if (page) {
        meta.title = meta.title.replace(" | Emiratescort", "");
        meta.title += ` – Page ${page} | Emiratescort.com`;
        meta.h1 += ` – Page ${page}`;
      }

      return meta;
    },

    breadcrumbsItems() {
      let pos = 1;
      const items = [
        {
          href: "/",
          text: this.$t("nav.home"),
          pos: pos++,
          disabled: false,
        },
      ];

      let locationUrl = `/${this.currentCityUrl}`;

      if (this.currentCity?.id) {
        items.push({
          href: `/${this.currentCityUrl}`,
          text: this.currentCity.name,
          pos: pos++,
          disabled: false,
        });
      }

      let areaUrl;

      if (this.decodedDistrict) {
        areaUrl = `/${this.currentCityUrl}-${spacesToDashes(
          this.decodedDistrict.title
        )}`;
        locationUrl = `/${this.currentCityUrl}-${spacesToDashes(
          this.decodedDistrict.title
        )}`;
      }

      if (areaUrl) {
        items.push({
          href: areaUrl,
          text: this.decodedDistrict.title,
          pos: pos++,
          disabled: false,
        });
      }
      let paramsPath = "";
      Object.keys(this.$route.params).forEach((key) => {
        if (key != "catalog_first_level") {
          const param = this.$route.params[key];
          if (param) {
            paramsPath += `/${param}`;
            items.push({
              href: `${locationUrl}${paramsPath}`,
              text: param.replace("-nationality", ""),
              pos: pos++,
              disabled: false,
            });
          }
        }
      });

      let lastItem = items[items.length - 1];
      if (lastItem) {
        lastItem.disabled = true;
      }

      return items;
    },
  },

  methods: {
    ...mapMutations({
      setCatalogMode: "catalog/setCatalogMode",
      setMinCol: "catalog/setMinCol",
    }),

    setViewWithColl(mode, col, legend) {
      this.setCatalogMode(mode);
      this.setMinCol(col);
      if (legend !== undefined) {
        this.$store.commit("global/setShowLegend", legend);
      }
    },

    processServiceMeta() {
      const meta = {};

      let category = this.catalogPageRequestData?.category;
      let subcategory = this.catalogPageRequestData?.subcategory;

      // POPULAR SERVICES
      if (category && category.toLowerCase().includes("popular")) {
        return {
          title: this.$t(
            "seo.catalog.third-level.service.from-seo.popular.title",
            [subcategory.replace(" escort", "")]
          ),
          description: this.$t(
            "seo.catalog.third-level.service.from-seo.popular.description",
            [subcategory.replace(" escort", ""), this.currentCity.name]
          ),
        };
      }
      // FETISH SERVICES
      else if (category && category.toLowerCase().includes("fetish")) {
        return {
          title: this.$t(
            "seo.catalog.third-level.service.from-seo.fetish.title",
            [subcategory.replace(" escort", "")]
          ),
          description: this.$t(
            "seo.catalog.third-level.service.from-seo.fetish.description",
            [subcategory.replace(" escort", ""), this.currentCity.name]
          ),
        };
      }
      // MASSAGE SERVICES
      else if (category && category.toLowerCase().includes("massage")) {
        return {
          title: this.$t(
            "seo.catalog.third-level.service.from-seo.massage.title",
            [subcategory.replace(" escort", "")]
          ),
          description: this.$t(
            "seo.catalog.third-level.service.from-seo.massage.description",
            [subcategory.replace(" escort", ""), this.currentCity.name]
          ),
        };
      }
      // OTHER SERVICES
      else if (category && category.toLowerCase().includes("other")) {
        return {
          title: capitalize(
            this.$t("seo.catalog.third-level.service.from-seo.other.title", [
              subcategory.replace(" escort", ""),
            ])
          ),
          description: this.$t(
            "seo.catalog.third-level.service.from-seo.other.description",
            [subcategory.replace(" escort", ""), this.currentCity.name]
          ),
        };
      }

      return meta;
    },
  },
};
